
<template>
    <v-card outlined d-flex wrap class="main pa-0">
        <v-overlay :value="loadingPedido" absolute>
            <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-col class="pa-0">
<!-- Header Tela -->
            <v-row class="mt-6 ml-5 pr-6">
                <span class="data-info">Pedido de ração Nº {{ pedido.nrPedido }} </span>
                    <span v-if="pedido.historico.dhStatusCancelado" class="cancelado">
                        &nbsp;- Pedido Cancelado
                    </span>
                <v-spacer/>
<!-- Btn cancelar -->
            <span v-if="!pedido.historico.dhStatusCancelado || (!pedido.historico.dhStatusCancelado && !pedido.historico.dhStatusEntrega )">
                <span v-if="!pedido.historico.dhStatusConfirmado || !pedido.historico.dhStatusSaiuEntrega &&
                            (pedido.historico.dhStatusConfirmado && !editarCampos)" >
                    <v-dialog v-model="cancelarPedidoDialog" width="500">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="btn-cancelar" color="#FF5252" outlined v-bind="attrs" v-on="on">
                                Cancelar pedido
                            </v-btn>
                        </template>

                        <v-card>
                            <v-card-title  class="dialog-titulo">
                                Cancelar Pedido
                            </v-card-title>
                            <v-card-text class="pb-0 mb-0 pt-3 flex-column">
                                <span class="dialog-label">Motivo</span>
                                <v-textarea color="#BDCCCA" outlined
                                            placeholder="Descreva o motivo do cancelamento do pedido"
                                ></v-textarea>
                            </v-card-text>
                            <v-card-actions class="mx-3 pb-4">
                                <v-btn class="btn-cancelar" color="#FF5252" outlined
                                       @click="cancelarPedidoDialog = false">
                                    Voltar
                                </v-btn>
                                <v-spacer />
                                <v-btn color="#2BC1B6" dark elevation="0" class="ml-2" @click="cancelarPedido()">
                                    Cancelar Pedido
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </span>

<!-- Btn Confirmar Pedido -->
                <v-btn v-if="!pedido.historico.dhStatusConfirmado"  @click="atualizaStatus(2)"
                       color="#2BC1B6" elevation="0" class="ml-2 white--text">
                    Confirmar pedido
                </v-btn>
                
<!-- Btn Alterar Pedido -->
                <v-btn v-if="pedido.historico.dhStatusConfirmado && !pedido.historico.dhStatusEntrega && editarCampos"
                       class="btn-cancelar"
                       color="#FF5252" outlined @click="cancelarAlteracao()">
                    Cancelar Alteracao
                </v-btn>
                <v-btn v-if="!pedido.historico.dhStatusEntrega && editarCampos && pedido.historico.dhStatusConfirmado"
                       color="#2BC1B6" @click="atualizaStatus(2)"
                       elevation="0" :disabled="(!pedido.dtPrevisaoEntrega && !pedido.cdFabricaRacao) ||
                               (alterardtPrevisaoEntrega === pedido.dtPrevisaoEntrega &&
                                alteraridFabricaRacao === pedido.idFabricaRacao)" class="ml-2 white--text">
                    Alterar pedido
                </v-btn>

<!-- Btn Saiu para entrega -->
                <span v-else-if="pedido.historico.dhStatusConfirmado && !pedido.historico.dhStatusSaiuEntrega">
                    <v-btn color="#2BC1B6" elevation="0" class="ml-2 white--text"
                           @click.stop="limparNF()">
                        Saiu para entrega
                    </v-btn>
                    <nota-fiscal-dialog :pedido.sync="pedido" :saiuEntregaDialog.sync="saiuEntregaDialog"
                                        :listaRacao="listaRacao" @lancarNF="lancarNF()" ref="NFSaiuEntrega">
                    </nota-fiscal-dialog>
                </span>
                </span>
            </v-row>
            <v-row>
                <v-col cols="3" class="pa-0" style="min-width: 270px">
<!-- Timeline -->
                    <timeline-pedido :pedido="pedido" :listaRacao="listaRacao"/>
                </v-col>
<!-- Divisor -->
                <v-divider inset vertical class="mx-4"/>

                <v-col class="pt-0">
                    <span class="subheader">Dados</span>

<!-- Campos Descrição -->
                    <campos-descricao :editarCampos.sync="editarCampos" :pedido.sync="pedido"
                                      :listaFabricaRacao="listaFabricaRacao" ref="camposDescricao"
                                      :idFabricaRacao.sync="alteraridFabricaRacao" :dtPrevisaoEntrega.sync="alterardtPrevisaoEntrega" />
                    <v-row>
<!-- Mapa -->
                        <v-card style="overflow: hidden">
                            <mapa-pedido class="d-flex flex-nowrap" :bl-confirmado="blConfirmado" />
                        </v-card>
                    </v-row>
                </v-col>
            </v-row>
            <v-row class="mt-10 ml-2">
                    <v-btn color="#e3e7e8" elevation="2" rounded class="ml-2" :to="{ name: 'pedidosRacao' }" >
                    <v-icon small class="mr-2">fa-arrow-left</v-icon>
                    Voltar
                </v-btn>
            </v-row>
        </v-col>
    </v-card>
</template>

<script>
import * as moment from "moment";
import MapaPedido from "@/modules/pedidosRacao/components/detalhePedido/MapaPedido";
import TimelinePedido from "@/modules/pedidosRacao/components/detalhePedido/TimelinePedido";
import NotaFiscalDialog from "@/modules/pedidosRacao/components/detalhePedido/NotaFiscalDialog";
import CamposDescricao from "@/modules/pedidosRacao/components/detalhePedido/CamposDescricao";
import {STRINGS, MODELS, URLS} from "@/modules/pedidosRacao/resources";

export default {
    name: "detalhePedido.vue",
    components: {NotaFiscalDialog, CamposDescricao, TimelinePedido, MapaPedido},
    data() {
        return {
            loadingPedido: false,
            cancelarPedidoDialog: false,
            listaFabricaRacao: [],
            listaRacao: [],
            saiuEntregaDialog: false,
            editarCampos: false,
            pedido: MODELS.PEDIDO,
            alteraridFabricaRacao: 0,
            alterardtPrevisaoEntrega: '',
            racaoSelecionada: 0,
        }
    },
    computed: {
        blConfirmado() {
            if(!this.pedido.historico.dhStatusConfirmado) return false
            if(!this.pedido.historico.dhStatusCancelado) return false
            return true
        }
    },
    filters: {
        formataData(date, ISO, formatoSaida) {
            let tipoData = ISO ? moment.ISO_8601 : 'YYYY-MM-DD';
            const parsedDate = moment(date, tipoData);
            if (!parsedDate.isValid()) return "";
            return parsedDate.format(formatoSaida);
        },
    },
    methods: {
        cancelarPedido() {
            this.cancelarPedidoDialog = false;

            this.atualizaStatus(5);
        },
        atualizaStatus(cdStatusPedidoRacao) {
            if (cdStatusPedidoRacao === 5 || this.$refs.camposDescricao.$refs.camposDescricaoForm.validate())
            {
                this.loadingPedido = true;

                if (cdStatusPedidoRacao === 4) {
                    const dataAtual = moment();
                    this.pedido.historico.dtEntrega = dataAtual.format('YYYY-MM-DD');
                    this.pedido.historico.hrEntrega = dataAtual.format('HH:MM');
                }

                let rec = {
                    cdPedidoRacao: this.pedido.nrPedido,
                    cd_status_pedido_racao: cdStatusPedidoRacao,
                    dt_prevista: this.alterardtPrevisaoEntrega,
                    cd_fabrica_racao: this.alteraridFabricaRacao,
                    ds_observacao: this.pedido.dsObservacao,
                    dt_chegada: this.pedido.historico.dtEntrega ? this.pedido.historico.dtEntrega : null,
                    hr_chegada: this.pedido.historico.hrEntrega ? this.pedido.historico.hrEntrega : null
                }
                if(this.pedido.racoes[0] && this.pedido.racoes[0].codigo) {
                    rec.racoes = this.pedido.racoes;
                    rec.racoes.forEach(v => v.codigo = v.codigo.toString());
                }

                if(this.pedido.nrNotaFiscal) rec.nf = Number.parseInt(this.pedido.nrNotaFiscal.replace('-',''));

                this.$axios.post(URLS.ATUALIZASTATUS, rec)
                    .then(() => {
                        this.$store.commit('setSnack', {type: 'success', msg: STRINGS.MensagemSuccessSave});
                    })
                    .catch((error) => {
                        this.$store.commit('setSnack', {type: 'error', msg: error});
                    }).
                    finally(() => {
                        this.loadPedido();
                        this.loadingPedido = false;
                    })
            }
            else {
                this.$store.commit('setSnack', {type: 'error', msg: STRINGS.CamposInvalidos});
            }
        },
        loadPedido() {
            this.$axios
                .get(
                  process.env.VUE_APP_URL_API + URLS.PEDIDORACAO + this.$route.params.id + URLS.MODOGETBYID
                )
                .then(res => {
                    if (!res.data[0]) return
                    if (!res.data[0].data) return

                    const response = res.data[0].data;

                    const findProp = function (campo, cdStatus, reverse){
                        if(!response.listaStatus.find(v => v.cdStatusPedidoRacao === cdStatus))
                            return null
                        else if(reverse)
                            return response.listaStatus.reverse().find(v => v.cdStatusPedidoRacao === cdStatus)[campo]
                        else(response.listaStatus.find(v => v.cdStatusPedidoRacao === cdStatus))
                            return response.listaStatus.find(v => v.cdStatusPedidoRacao === cdStatus)[campo]
                    };

                    this.pedido.nrPedido = response.idPedidoRacao;
                    this.pedido.cdLoteProducao = response.cdLoteProducao;
                    this.pedido.nmProdutor = response.loteProducao.jsonProdutor.nmProdutor;
                    this.pedido.nrUep = response.loteProducao.jsonUnidadeExploracao.nrUnidadeExploracao;
                    this.pedido.dsObservacao = response.dsObservacao;
                    this.pedido.dtEntregaDesejada = response.dtDesejada;
                    this.pedido.dtPrevisaoEntrega = response.dtPrevista;

                    this.pedido.qtCapacidadeSilo = response.qtCapacidadeSilos !== null ? response.qtCapacidadeSilos : -1

                    this.pedido.idFabricaRacao = findProp('cdFabricaRacao', 2, true);
                    this.pedido.nrNotaFiscal = findProp('dsObservacao', 3) ?
                                        findProp('dsObservacao', 3).substr(4,6) :
                                        '';
                    this.pedido.historico = {
                        dhStatusSolicitado: findProp('dhStatus', 1),
                        dhStatusConfirmado: findProp('dhStatus', 2),
                        listaConfirmado: response.listaStatus
                            .filter(v => v.cdStatusPedidoRacao === 2)
                            .map(v => ({
                                    dhStatusConfirmado: v.dhStatus,
                                    dsStatusObservacao: v.dsObservacao
                                })
                            ),
                        dtPrevista: findProp('dtPrevista', 2, true),
                        dhStatusSaiuEntrega: findProp('dhStatus', 3),
                        dhStatusEntrega: findProp('dhStatus', 4),
                        dtEntrega: findProp('dtChegada', 4),
                        hrEntrega: findProp('hrChegada', 4),
                        dhStatusCancelado: findProp('dhStatus', 5),
                    };
                    this.pedido.dsObservacaoCancelado = findProp('dsObservacao', 5);

                    this.alteraridFabricaRacao = this.pedido.idFabricaRacao;
                    this.alterardtPrevisaoEntrega = this.pedido.dtPrevisaoEntrega;

                    this.editarCampos = !(this.alteraridFabricaRacao && this.alterardtPrevisaoEntrega)

                    this.loadRacoesPedido();
                    this.loadEntradasRacoesLote();
                })
                .catch(error => {
                  this.$store.commit("setSnack", { type: "error", msg: error });
                });
        },
        loadFabricaRacao() {
            this.$axios
                .get(
                  process.env.VUE_APP_URL_API + URLS.FABRICARACAO
                )
                .then(res => {
                    if (!res.data[0]) return
                    if (!res.data[0].data) return

                    this.listaFabricaRacao = res.data[0].data;
                })
                .catch(error => {
                  this.$store.commit("setSnack", { type: "error", msg: error });
                });
        },
        loadRacao() {
            this.$axios.get(URLS.RACAO)
                .then((response) => {
                    if (!response.data) return
                    if (!response.data[0].data) return

                    this.listaRacao = response.data[0].data;
                })
                .catch( error => {
                    this.$store.commit('setSnack', {type: 'error', msg: error})
                })
        },
        loadSugestaoPedido() {
            if(!this.alterardtPrevisaoEntrega) return

            this.$axios
                .get( process.env.VUE_APP_URL_API + URLS.SUGESTAOPEDIDO,
                    { params: {
                                cdLoteProducao: this.pedido.cdLoteProducao,
                                dtPedidoRacao: this.alterardtPrevisaoEntrega,
                            }
                    }
                )
                .then(res => {
                    if (!res.data[0]) return
                    if (!res.data[0].data) return

                    const response = res.data[0].data;

                    if (response.errorMessage) this.$store.commit("setSnack",
                        { type: "error", msg: response.errorMessage })

                    if (response.errorMessage) this.$store.commit("setSnack", { type: "error", msg: response.errorMessage });

                    this.pedido.qtSiloDisponivel = response.qtSiloDisponivel !== null ? response.qtSiloDisponivel : -1;
                    this.pedido.dsTipoRacao = response.racao && response.racao.nmRacao ? response.racao.nmRacao : '';
                    this.pedido.qtSugestao = response.qtSugestao !== null ? response.qtSugestao : -1;
                })
                .catch(error => {
                  this.$store.commit("setSnack", { type: "error", msg: error });
                });
        },
        loadRacoesPedido() {
            if (this.pedido.historico.dhStatusSaiuEntrega)
            {
                this.$axios
                .get(
                  process.env.VUE_APP_URL_API + URLS.ENTRADARACAO, { params: {
                      'cd_pedido_racao': this.$route.params.id
                    }
                  }
                )
                .then(res => {
                    if (!res.data[0]) return
                    if (!res.data[0].data) return

                    const response = res.data[0].data;

                    this.pedido.qtItensNF = response.length;
                    this.pedido.nrNotaFiscal = response[0].nrNotaFiscal;

                    this.pedido.racoes = response.map(v => ({
                        codigo: v.racao.cdItem,
                        quantidade: v.qtRacao,
                        lote: v.dsPartida
                    }));
                })
                .catch(error => {
                  this.$store.commit("setSnack", { type: "error", msg: error });
                });
            }
        },
        loadEntradasRacoesLote() {
            this.$axios
                .get(
                    process.env.VUE_APP_URL_API + URLS.ENTRADARACAO, {
                        params: {
                            'cd_lote_producao': this.pedido.cdLoteProducao
                        }
                    }
                )
                .then(res => {
                    if (!res.data[0]) return
                    if (!res.data[0].data) return

                    const response = res.data[0].data;

                    this.pedido.dsUltimaEnviada = response[0].racao.nmRacao;
                })
                .catch(error => {
                    this.$store.commit("setSnack", {type: "error", msg: error});
                });
        },
        cancelarAlteracao() {
            this.alterardtPrevisaoEntrega = this.pedido.dtPrevisaoEntrega;
            this.alteraridFabricaRacao = this.pedido.idFabricaRacao;
            this.editarCampos = false;
        },
        lancarNF() {
            this.saiuEntregaDialog = false;
            this.atualizaStatus(3);
        },
        limparNF() {
            if (this.$refs.camposDescricao.$refs.camposDescricaoForm.validate()){
                this.$refs.NFSaiuEntrega.$refs.formSaiuParaEntrega && this.$refs.NFSaiuEntrega.$refs.formSaiuParaEntrega.reset();
                this.pedido.nrNotaFiscal = '';
                this.pedido.qtItensNF = 0;
                this.pedido.racoes = [];
                this.saiuEntregaDialog = true;
            }
            else {
                this.$store.commit('setSnack', {type: 'error', msg: STRINGS.CamposInvalidos});
            }
        },
        limparSugestaoPedido(){
            this.pedido.qtSiloDisponivel = -1
            this.pedido.dsTipoRacao = '';
            this.pedido.qtSugestao = -1;
        }
    },
    watch: {
        alterardtPrevisaoEntrega(newValue) {
            if(this.pedido.dtPrevisaoEntrega !== newValue) this.loadSugestaoPedido();
        }
    },
    created() {
        this.limparSugestaoPedido()
        this.loadRacao();
        this.loadPedido();
        this.loadFabricaRacao();
    },
}
</script>

<style scoped lang="scss">
@import "../sass/variables.scss";

.data-info {
  text-align: left;
  font: normal normal bold 24px/32px Roboto;
  letter-spacing: 0;
  color: $gray-200;
}

.main {
  margin: 0 0 0 40px;
  height: 100%;
}

.subheader {
  text-align: left;
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
  color: $gray-100;
  opacity: 0.7;
}

.dialog-label {
  text-align: left;
  font: normal normal medium 16px/21px Roboto;
  letter-spacing: 0;
  color: $gray-300;
  opacity: 0.7;
}

.dialog-titulo {
  text-align: left;
  font: normal 300 normal 16px/21px Roboto !important;
  letter-spacing: 0;
  color: $gray-500;
  opacity: 1;
  background-color: $gray-100
}

.descricao-evento-historico .v-icon {
  color: $blue-200;
}

.list-item-ativo {
  background: $gray-100 0 0 no-repeat padding-box;
  opacity: 0.05;
}

.data-info {
  text-align: left;
  font: normal normal bold 24px/32px Roboto;
  letter-spacing: 0;
  color: $gray-200;
}

.cancelado {
  font: normal normal normal  22px/32px Roboto;
  color: $color-error
}

.v-overlay {
  z-index: 9000;
  left: -40px;
  right: -40px;
  width: 100vw;
}
</style>